import actionComposer from 'utilities/actionComposer';
import { queryContentStackByUrl } from 'utilities/contentStack';

export const GET_LEGAL_STACK = actionComposer('GET_LEGAL_STACK');
export const getLegalStack = url => ({
  type: GET_LEGAL_STACK.type,
  payload: queryContentStackByUrl('legal_stuff', url)
});
